import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import VueScrollto from 'vue-scrollto'
import { ObserveVisibility } from 'vue-observe-visibility'
import Vue2TouchEvents from 'vue2-touch-events'
import VueAwesomeSwiper from 'vue-awesome-swiper'

import '@/assets/stylus/main.styl'
import 'swiper/dist/css/swiper.css'
import '@/components/ui'
import '@/components/icons'

Vue.config.productionTip = false
Vue.use(VueScrollto)
Vue.use(Vue2TouchEvents)
Vue.use(VueAwesomeSwiper)
Vue.directive('obvis', ObserveVisibility)

new Vue({
    router,
    store,
    mounted: () => document.dispatchEvent(new Event('x-app-rendered')),
    render: h => h(App)
}).$mount('#app')
